<div class="detail-page">
  <app-asiakas-otsikko [otsikko]="otsikko" [naytaPalaa]="true" [paluuUrl]="'/asiakkaat/' + $safeNavigationMigration(asiakas?.avain) + '/laskutus'" [asiakas]="asiakas"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Lasku: <a [href]="laskuEncodedUriObservable | async" target="_BLANK">{{ laskuUriObservable | async }}</a>
      </div>
      <div style="padding-left: 1em; padding-right: 1em">
        Mahdollinen Kirjattava kuitti: <a [href]="kirjattavakuittiEncodedUriObservable | async" target="_BLANK">{{ kirjattavakuittiUriObservable | async }}</a>
      </div>
    </div>
  }

  <div class="otsake-container">
    <!-- <button class="sulje light-blue-text" mat-button (click)="peruuta()" type="button">
    <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block;" class="icon ion-md-arrow-back"></i>
  </button> -->

    <div class="otsake">
      <!-- <div *ngIf="naytaKorvatunOtsake()">
    <span>{{'lasku.katsele-muokattava-dialog.lasku' | translate | async}}</span>
    <h2 class="light-blue-text">{{annaKorvatunOtsake()}}</h2>
  </div>
  <div *ngIf="naytaTavallinenOtsake()">
    <span>{{'lasku.katsele-muokattava-dialog.lasku' | translate | async}}</span>
    <h2 class="light-blue-text">{{laskuSharedService.annaMuotoiltuLaskunumero(kasiteltava)}} {{kasiteltava?.asiakas?.nimi}}</h2>
  </div> -->
      @if (naytaMaksuaikaa()) {
        <div>
          <span>{{ 'lasku.katsele-muokattava-dialog.maksuaikaa' | translate | async }}</span>
          <h2 [class.light-blue-text]="annaMaksuaikaa() > -1" [class.red-text]="annaMaksuaikaa() < 0">{{ annaMaksuaikaa() }} pv</h2>
        </div>
      }
      @if (naytaSumma()) {
        <div>
          <span>
            {{ 'lasku.tila.' + $safeNavigationMigration(juurilasku?.tila) | translate | async }}
          </span>
          @if (juurilasku?.tila == 'm' || juurilasku?.tila == 'ml') {
            <h2 [class.purple-text]="juurilasku?.tila == 'ml'" [class.green-text]="juurilasku?.tila == 'm'">{{ reskontraSummaObservable | async | lmoney: kasiteltava?.valuutta | async }}</h2>
          } @else {
            <h2 [class.blue-text]="vertaaYhtaSuuret($safeNavigationMigration(kasiteltava?.avoinna), $safeNavigationMigration(kasiteltava?.summa)) && juurilasku?.tila == 'a'" [class.red-text]="juurilasku?.tila == 'e'" [class.yellow-text]="vertaaEkaPienempiKuinToka(kasiteltava?.avoinna, kasiteltava?.summa) && vertaaEkaPienempiKuinToka(0, kasiteltava?.avoinna) && juurilasku?.tila == 'a'">
              {{ kasiteltava?.avoinna | lmoney: kasiteltava?.valuutta | async }}
            </h2>
          }
        </div>
      }
    </div>
  </div>

  <div class="nappula-container">
    <div class="nappulat">
      <!-- *ngIf="nakyvyystiedotObservable | async; as nakyvyystiedot" -->

      <div>
        <!-- <button mat-button class="secondarybutton" (click)="muokkaa()" *ngIf="nakyvyystiedot.onkoMuokkaaNakyvissa">{{'lasku.katsele-muokattava-dialog.muokkaa' | translate | async}}</button> -->
        <!-- <button mat-button class="secondarybutton" (click)="naytaMuokkausEstettyDialogi()" *ngIf="nakyvyystiedot.onkoMuokkaaInfoNakyvissa">{{'lasku.katsele-muokattava-dialog.muokkaa' | translate | async}}</button> -->
        <!-- <button mat-button class="secondarybutton" >
      <mat-icon>info</mat-icon>
    </button> -->
        <!-- <button mat-button class="secondarybutton" (click)="kopioiUusiLasku()" *ngIf="nakyvyystiedot.onkoKopioiUusiLaskuNakyvissa">{{'lasku.katsele-muokattava-dialog.kopioi-uusi-lasku' | translate | async}}</button>
    <button mat-button class="secondarybutton" (click)="poistaLuonnos()" *ngIf="nakyvyystiedot.onkoPoistoLuonnosNakyvissa">{{'lasku.katsele-muokattava-dialog.poista-luonnos' | translate | async}}</button> -->
        @if (onkoHyvitysNakyvissa()) {
          <app-secondary-button mat-button class="secondarybutton" (click)="hyvita()" actionId="Hyvitä asiakkaan lasku">{{ 'lasku.katsele-muokattava-dialog.hyvita' | translate | async }}</app-secondary-button>
        }
        @if (onkoLataaLaskuNakyvissa()) {
          <app-secondary-button (click)="lataaLasku()" actionId="Lataa laskun pdf koneelle">
            {{ 'lasku.katsele-muokattava-dialog.lataa-lasku' | translate | async }}
          </app-secondary-button>
        }
      </div>

      <div>
        <!-- <button mat-button class="secondarybutton" (click)="merkitseOsittainMaksetuksi()" *ngIf="nakyvyystiedot.onkoMerkitseOsittainMaksetuksiNakyvissa">{{ 'lasku.katsele-muokattava-dialog.merkitse-osittain-maksetuksi' | translate | async }}</button>
    <button mat-button class="secondarybutton" (click)="lahetaMuistutuslasku()" *ngIf="nakyvyystiedot.onkoMaksumuistutusNakyvissa">{{ 'lasku.katsele-muokattava-dialog.laheta-maksumuistutus' | translate | async }}</button>
    <button mat-button class="secondarybutton" (click)="lahetaPerintaritarimuistutuslasku()" *ngIf="naytaPerintaritari && nakyvyystiedot.onkoMaksumuistutusNakyvissa">{{ 'lasku.katsele-muokattava-dialog.laheta-maksumuistutus' | translate | async }} (Perintäritari)</button>
    <button mat-button class="secondarybutton" (click)="peruutaLuottotappiomerkinta()" *ngIf="nakyvyystiedot.onkoPeruutaLuottotappioMerkintaNakyvissa">{{ 'lasku.katsele-muokattava-dialog.peruuta-merkitse-luottotappioksi' | translate | async }}</button>
    <button mat-button class="secondarybutton" (click)="merkitseLuottotappioksi()" *ngIf="nakyvyystiedot.onkoMerkitseLuottotappioksiNakyvissa">{{ 'lasku.katsele-muokattava-dialog.merkitse-luottotappioksi' | translate | async }}</button> -->
      </div>

      @if (kirjanpitajaOnDevaajaTaiTukiObservable | async) {
        <div>
          <app-secondary-button (click)="laskeReskontraUudelleen()" actionId="Laske laskun reskontra uudelleen"> LASKE RESKONTRA UUDELLEEN </app-secondary-button>
          @if (kirjanpitajaOnDevaajaObservable | async) {
            <app-secondary-button (click)="paivitaTilaJaIndeksoiUudelleen()" actionId="Päivitä laskun tila ja indeksoi uudelleen"> PAIVITA TILA JA INDEKSOI UUDELLEEN </app-secondary-button>
          }
        </div>
      }
    </div>

    @if (naytaEpaonnistunutSahkoinen()) {
      <mat-card appearance="outlined" class="laheta-uudelleen">
        <mat-card-header>
          <mat-card-title>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.lahettaminen-epaonnistui' | translate | async }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form novalidate>
            <mat-form-field>
              <mat-label>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.valittaja' | translate | async }}</mat-label>
              <mat-select [formField]="sahkoinenLomake.valittaja">
                @for (operator of verkkolaskuoperaattorit; track operator) {
                  <mat-option [value]="operator.tunnus"> {{ operator.nimi }} ({{ operator.tunnus }}) </mat-option>
                }
              </mat-select>
              @if (onkoVirhe(sahkoinenLomake.valittaja, 'required') && (sahkoinenLomake.valittaja().dirty() || sahkoinenLomake.valittaja().touched())) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.valittaja.required' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.osoite' | translate | async }}</mat-label>
              <input type="text" [formField]="sahkoinenLomake.osoite" matInput />
              <mat-hint>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.virheellinen-osoite' | translate | async }}</mat-hint>
              @if (onkoVirhe(sahkoinenLomake.osoite, 'required') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.required' | translate | async }}</mat-error>
              }
              @if (onkoVirhe(sahkoinenLomake.osoite, 'valittaja') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.valittaja' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <app-primary-button (click)="lahetaSahkoinenUudelleen()" actionId="Lähetä sähköinen lasku uudelleen">
              {{ 'lasku.katsele-muokattava-dialog.uudelleen-lahetys' | translate | async }}
            </app-primary-button>
          </form>
        </mat-card-content>
      </mat-card>
      <div><b>Osoitekyselyn tiedot</b></div>
      <pre>{{ $safeNavigationMigration(kasiteltava?.sahkoinen?.latestAddressQueryReponse) | json }}</pre>
      <div><b>Lähetystiedot</b></div>
      <pre>{{ $safeNavigationMigration(kasiteltava?.sahkoinen?.latestSendResponse) | json }}</pre>
    }

    @if (naytaEpaonnistunutSposti()) {
      <mat-card appearance="outlined" class="laheta-uudelleen">
        <mat-card-header>
          <mat-card-title>{{ 'lasku.katsele-muokattava-dialog.spostien-lahettaminen-epaonnistui' | translate | async }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @for (vastaanottaja of kasiteltava?.email?.vastaanottajat; track vastaanottaja; let i = $index) {
            <div>
              @if (vastaanottaja.status == 3) {
                <form novalidate>
                  <mat-form-field>
                    <mat-label>{{ 'lasku.katsele-muokattava-dialog.spostin-lahetysvirhe' | translate | async }}</mat-label>
                    <input type="text" [formField]="vastaanottajienLomake[i]" matInput />
                    <mat-error>{{ 'lasku.katsele-muokattava-dialog.virheellinen-sahkoposti' | translate | async }}</mat-error>
                    <mat-hint align="start">{{ 'lasku.katsele-muokattava-dialog.tekninen-virhe' | translate | async }}: {{ vastaanottaja.viesti?.Description }} </mat-hint>
                  </mat-form-field>
                  <app-secondary-button (click)="naytaKokoVirhe(vastaanottaja)" actionId="Avasi laskun virhe dialogin">
                    {{ 'lasku.katsele-muokattava-dialog.koko-virheen-naytto' | translate | async }}
                  </app-secondary-button>
                  <app-primary-button (click)="lahetaEmailUudelleen($any(vastaanottaja))" actionId="Lähetä laskun email uudelleen">
                    {{ 'lasku.katsele-muokattava-dialog.uudelleen-lahetys' | translate | async }}
                  </app-primary-button>
                </form>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>
    }
  </div>

  <div style="max-width: 695px; width: 100%; margin-bottom: 25px">
    <lasku-pdf-esikatselu-perinteinen [tiedot]="esikatselutiedot"></lasku-pdf-esikatselu-perinteinen>
  </div>

  @if (kasiteltava?.liitteet && kasiteltava?.liitteet?.length > 0) {
    <div>
      <div class="light-blue-text" style="font-size: 1rem; margin-top: 40px; margin-bottom: 10px">Liitetiedostot</div>
      <mat-chip-listbox>
        @for (liite of kasiteltava?.liitteet; track liite) {
          <mat-chip-option style="cursor: pointer" (click)="lataaLiitetiedosto(liite)" [selectable]="false">
            {{ liite.nimi }}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
  }

  <div style="color: rgb(114, 115, 115); font-size: 12px">
    <div class="light-blue-text" style="font-size: 16px; margin-top: 40px; margin-bottom: 10px">{{ 'lasku.tapahtumaloki.otsikko' | translate | async }}</div>
    @if (lokitietojaLadataanObservable | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @for (loki of lokitiedotObservable | async; track loki) {
      <div (click)="naytaLoki(loki)" style="cursor: pointer">{{ loki.loki.pvm | ltimestamptime | async }}, {{ loki.tekija }}: {{ loki.viesti }}</div>
    }
  </div>

  <!-- <div style="color: rgb(114,115,115); font-size: 12px;">
<div class="light-blue-text" style="font-size: 16px; margin-top: 40px; margin-bottom: 10px;">
  {{ 'lasku.reskontra.otsikko' | translate | async }}
  Reskontrahistoria laskussa (Tarkemmat tiedot klikkaamalla)
</div>
<div *ngFor="let merkinta of juurilasku?.reskontra" (click)="naytaMerkinta(merkinta)" style="cursor: pointer;">
  {{ merkinta.pvm | ltimestamp | async }}: {{ merkinta.suoritus | lmoney: kasiteltava?.valuutta | async }}
</div>
</div> -->

  <div style="color: rgb(114, 115, 115); font-size: 12px">
    <div class="light-blue-text" style="font-size: 16px; margin-top: 40px; margin-bottom: 10px">
      <!-- {{ 'lasku.reskontra.otsikko' | translate | async }} -->
      Erillinen reskontrahistoria (Tarkemmat tiedot klikkaamalla)
    </div>
    @if (reskontraaLadataanObservable | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @for (merkinta of reskontraLokiObservable | async; track merkinta) {
      <div (click)="naytaMerkinta(merkinta.data)" style="cursor: pointer">
        {{ merkinta.teksti }}
      </div>
    }
  </div>

  <div style="color: rgb(114, 115, 115); font-size: 12px">
    <div class="light-blue-text" style="font-size: 16px; margin-top: 40px; margin-bottom: 10px">
      <!-- {{ 'lasku.reskontra.otsikko' | translate | async }} -->
      Laskun omistaja
    </div>
    @if (tilastotiedotObservable | async; as tiedot) {
      <p>{{ tiedot.nimi }}, {{ tiedot.tiimi }}</p>
    }

    @if (tilastoKirjanpitajaTaiSuperObservable | async) {
      <form novalidate>
        <div class="vasenp">
          <mat-form-field style="width: 200px; margin-right: 20px">
            <mat-label>Uusi omistaja</mat-label>
            <mat-select [formField]="tilastoLomake.kirjanpitaja" [compareWith]="compareKirjanpitajat">
              @for (kirjanpitaja of kirjanpitajienNimiTiedotObservable | async; track kirjanpitaja) {
                <mat-option [value]="kirjanpitaja"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width: 300px; margin-right: 20px">
            <mat-label>Tiimi</mat-label>
            <mat-select [formField]="tilastoLomake.tiimi" [compareWith]="compareTiimit">
              @for (tiimiJaNimi of tiimitJaNimetObservable | async; track tiimiJaNimi) {
                <mat-option [value]="tiimiJaNimi.tiimi">
                  {{ tiimiJaNimi.nimi }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <app-primary-button (click)="vaihdaLaskunTilastoLemonator()" [disabled]="tilastoLomake().invalid()" actionId="Vaihda laskun tilasto" [actionContext]="[$any(tilastoLomake().value())]" styles="margin-right: .5em;"> Vaihda </app-primary-button>
          <p style="color: lightgrey">Huom! Osa henkilöistä useammassa tiimissä.</p>
          @if (naytaKampanjahyvitysInfoObservable | async) {
            <p class="kampanjahyvitys-info">
              <mat-icon>info</mat-icon>
              Kampanjahyvitys-tuotteella on oma tilastonsa, eikä tehty muutos vaikuta siihen.
            </p>
          }
        </div>
      </form>
    }
  </div>
</div>
